import { Box, Typography } from "@mui/material";
import CountryPickerNew from "../CountryPicker/CountryPickerNew";

interface CountryPickerUpdaterProps {
  label: string;
  value: string | undefined;
  setValue: Function;
}

const tfLabelProps = {
  sx: {
    color: "#6f7d95",
    fontSize: "1rem !important",
    fontWeight: 600,
    "&.MuiOutlinedInput-notchedOutline": {
      fontSize: "28px",
      border: "0px !important",
    },
  },
};

const CountryPickerUpdater = ({
  label,
  setValue,
  value,
}: CountryPickerUpdaterProps) => {
  return (
    <Box sx={{ width: "100%" }}>
      <Typography variant="body1" sx={tfLabelProps.sx}>
        {label}
      </Typography>

      <CountryPickerNew value={value} label={label} setValue={setValue} />
    </Box>
  );
};

export default CountryPickerUpdater;
